import {styled, Box} from 'external/material'
import Homeworks from './Homeworks'
import { centerVertically } from 'utils/style'

const StyledHomeworks = styled(Box)(homeworksStyles)

export default function HomeworksPage() {
  return (
  <StyledHomeworks className="container">
    <Homeworks />
  </StyledHomeworks>
  )
}

function homeworksStyles() {
  return {
    "& .homeworks": {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      backgroundColor: '#fff',
      borderRadius: 5,
      transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',
      "& .assessmentsPaging": {
        flexGrow: 1,
        display: 'flex',
        paddingBottom: 10,
        flexDirection: 'column',
        justifyContent: 'flex-end'
      },
      "& .MuiTableBody-root": {
        "& .MuiTableRow-root": {
          "&:nth-of-type(odd)": {
            backgroundColor: '#f8fbfd'
          },
          "& .MuiTableCell-root": {
            color: '#4d5874',
            borderBottom: 0,
          }
        }
      }
    },
    "& .MuiTableRow-root": {
      marginTop: 5,
      backgroundColor: '#fff',
      borderRadius: 5
    },
    "& .availability-cell": {
    },
    "& .view-homework-wrapper": {
      ...centerVertically,
      "& > .view-homework-container": {
        display: 'flex',
        justifyContent: 'center',
        "& > .view-homework-link": {
          textDecoration: 'none',
          padding: '4px 20px',
          color: '#2773bf',
          borderRadius: 20,
          border: 'solid 1px #2773bf',
          cursor: 'pointer',
          width: 100,
        }
      }
    },
    "& .start": {
      fontSize: '10pt',
    },
    "& .finish": {
      fontSize: '10pt',
    },
    "& .timer-container": {
      display: 'flex',
      justifyContent: 'center',
      flexGrow: 1,
      marginLeft: 12,
      fontSize: '10pt',
      color: '#2773bf',
      cursor: 'default',
      padding: '4px 20px',
      borderRadius: 20,
      border: 'solid 1px #2773bf',
      cursor: 'pointer',
      width: 100,
    },
    "& .statusName": {
        padding: '5px',
        color: '#fff',
        borderRadius: '20px',
        display: 'inline-block',
        width: 100,
        textAlign: 'center',
        '&.assigned': {
          backgroundColor: '#f78d43'
        },
        '&.completed': {
          backgroundColor: '#06b71c'
        },
        '&.pending': {
          backgroundColor: '#0ac7ff'
        },
        '&.returned': {
          backgroundColor: '#ff0a0a'
        }
    },
  }
}
